import styled from 'styled-components';

// COLORS
import { BLACK, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  position: relative;
  padding: 48px;
  border-radius: 8px;
  color: ${WHITE};

  ${breakpoints.down('sm')} {
    padding: 24px;
  }

  ${breakpoints.down('xs')} {
    margin-top: 50px;
  }

  h3 {
    padding-right: 15px;

    ${breakpoints.down('sm')} {
      font-size: 24px !important;
    }
  }

  .list {
    display: flex;
    flex-direction: column;

    ${breakpoints.up('sm')} {
      flex-direction: row;
    }

    .item {
      display: flex;
      align-items: center;

      span {
        font-weight: 600;
        font-size: 16px;
      }

      svg {
        margin-right: 8px;
        width: 32px;
        height: 32px;
      }
    }
  }

  .channels {
    margin-top: 16px;

    &__item {
      background-color: ${WHITE};
      border-radius: 16px;
      max-width: 105px;
      max-height: 105px;
      padding: 13px;
    }

    &__icon {
      width: 100%;
      height: auto;
      position: relative;
    }

    ${breakpoints.down(1130)} {
      &__item {
        max-width: 66px;
        max-height: 66px;
        padding: 8px;
      }
    }
  }

  .banner-app {
    &__link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &__logo {
      width: 100%;
      max-width: 300px;

      &-img {
        border-radius: 24px;
        background-color: ${WHITE};
        width: 100%;
        height: auto;
      }

      ${breakpoints.up('sm')} {
        max-width: 237px;
      }
    }

    &__channels {
      margin-top: 24px;
    }

    &__desc {
      margin-bottom: 25px;
    }

    &__old-price {
      text-decoration-line: line-through;
      font-size: 1.4em;
      margin-bottom: 4px;
    }
  }
`;
export const SpecialPrice = styled.div`
  position: absolute;
  right: -30px;
  top: -30px;
  z-index: 300;

  .text-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;

    p {
      font-size: 14px;
      color: ${BLACK};
      text-align: center;
      line-height: 1;
      font-weight: 800;
      padding: 0 10px;
    }
  }
  svg {
    width: 94px;
    height: 98px;
  }
`;

export default Container;
